import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const landownerApi = {
    // lay danh sach chu dat
    getLandownerList: (params) => {
        const url = '/landlord';
        return axiosClient.get(url, { params: Utils.filterParams(params) });
    },

    // tao chu dat
    createLandowner: (params) => {
        const url = '/landlord/create';
        return axiosClient.post(url, params);
    },

    // cap nhat thong tin chu dat
    updateLandowner: (landlordId, params) => {
        const url = `/landlord/${landlordId}`;
        return axiosClient.put(url, params);
    },

    // xoa chu dat
    deleteLandowner: (landlordId) => {
        const url = `/landlord/${landlordId}`;
        return axiosClient.delete(url);
    },
};

export default landownerApi;
